import { render, staticRenderFns } from "./user-popover.vue?vue&type=template&id=7b6b0bcd&scoped=true&"
import script from "./user-popover.vue?vue&type=script&lang=js&"
export * from "./user-popover.vue?vue&type=script&lang=js&"
import style0 from "./user-popover.vue?vue&type=style&index=0&id=7b6b0bcd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6b0bcd",
  null
  
)

export default component.exports